// extracted by mini-css-extract-plugin
export default {"form":"Form_form__Bwoh5","text":"Form_text__kd+ZO","label":"Form_label__iflzz","input":"Form_input__434HN","textarea":"Form_textarea__FIgWb","formBtn":"Form_formBtn__56YZe"};